import React, {
    Fragment,
    useCallback,
    useEffect,
    useRef,
    useState,
} from "react"
import { GoogleMap } from "@react-google-maps/api"
import latlongtokm from "@riskyvaibhav/lat-long-to-km"

import { containerStyle, center, sortGrossier, styles } from "./util"
import { Spinner } from "./Spinner"

async function fetchGrossiers() {
    const response = await fetch(window.local_grossiers_object.api)

    try {
        if (response.ok) {
            return await response.json()
        }
    } catch (e) {
        throw new Error(`Something went wrong`)
    }

    throw new Error(`Something went wrong`)
}

function defaultProps() {
    const urlParams = new URLSearchParams(window.location.search)
    const location = urlParams.get("location")

    if (!location) {
        return false
    }

    return {
        location: location ? location : "",
    }
}

let hasBeenSet = defaultProps()

const Grossiers = () => {
    const [fields, setFields] = useState(
        hasBeenSet
            ? hasBeenSet
            : {
                  location: "",
              }
    )
    const [grossiers, setGrossiers] = useState([])
    const [visibleGrossiers, setVisibleGrossiers] = useState([])
    const [map, setMap] = useState(null)
    const [markers, setMarkers] = useState([])
    const [isLoading, setLoading] = useState(true)
    const ref = useRef()

    const onLoad = useCallback(async function callback(map) {
        map.setOptions({
            // styles: styles,
            disableDefaultUI: true,
        })
        setMap(map)
    }, [])

    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    useEffect(() => {
        if (hasBeenSet && map !== null) {
            handleSearch().then(() => {})
            hasBeenSet = false
        }
    }, [grossiers])

    useEffect(() => {
        setLoading(true)
        fetchGrossiers()
            .then(async (data) => {
                // const dataWithParsedSchedule = data.map((grossier) => {
                //     grossier.schedule = convertTime(
                //         JSON.parse(grossier.schedule)
                //     )
                //     return grossier
                // })

                setGrossiers(data)
                setVisibleGrossiers(data)
                setLoading(hasBeenSet)
            })
            .catch((error) => {
                setGrossiers([])
            })
    }, [])

    useEffect(() => {
        if (markers.length > 0) {
            return
        }

        markers.forEach((marker) => marker.setMap(null))

        const markersArray = visibleGrossiers.map((grossier) => {
            const marker = new google.maps.Marker({
                position: {
                    lat: grossier.latitude,
                    lng: grossier.longitude,
                },
                map: map,
                icon: {
                    url: window.local_grossiers_object.marker_path,
                },
            })

            const content = `
                <div class="infoWindow">
                    <h5 class="mb-1">${grossier.title}</h5>
                    <span class="block">${grossier.street}</span>
                    <span class="block">${grossier.zipcode}</span>
                    <span class="block">${grossier.city}</span>
                    <a target="_blank" class="text-primary" href="${grossier.url}">Naar website</a>
                </div>
            `

            const infoWindow = new google.maps.InfoWindow({
                content: content,
            })

            marker["grossier"] = grossier

            marker.addListener("click", function (e) {
                infoWindow.open(map, marker)
            })

            marker.addListener("mouseenter", function (e) {
                infoWindow.open(map, marker)
            })

            return marker
        })

        setMarkers(markersArray)

        return () => {
            markers.forEach((marker) => marker.setMap(null))
            setMarkers([])
        }
    }, [visibleGrossiers])

    function handleChange(e) {
        if (e.target.name === "location" && e.target.value === "") {
            setFields({
                location: "",
                radius: 0,
            })

            setVisibleGrossiers(grossiers)
        } else {
            setFields({
                ...fields,
                [e.target.name]: e.target.value,
            })
        }
    }

    function fetchGeolocation(location) {
        let args = {
            address: location,
        }

        if (typeof location === "object") {
            args = {
                location: location,
            }
        }

        const service = new window.google.maps.Geocoder()

        return new Promise((resolve, reject) => {
            service.geocode(args, (response, status) => {
                if (status === "OK") {
                    resolve(response)
                } else {
                    reject(response)
                }
            })
        })
    }

    async function handleSearch(e = false) {
        console.log("Submitting...")
        if (e) {
            e.preventDefault()
        }

        if (fields.location) {
            setLoading(true)
            const mapsData = await fetchGeolocation(
                `${fields.location}, Nederland`
            )
            const results = mapsData[0]

            grossiers.forEach((grossier, index) => {
                const km = latlongtokm(
                    grossier.latitude,
                    grossier.longitude,
                    results.geometry.location.lat(),
                    results.geometry.location.lng()
                )
                grossiers[index].distance = Math.round(km)
            })

            setGrossiers([...grossiers])
            setVisibleGrossiers([...grossiers])
            setLoading(false)

            if (ref.current) {
                window.scrollTo({
                    behavior: "smooth",
                    top: ref.current.offsetTop - 100,
                })
            }
        }
    }

    function resetFilter() {
        window.location.href = window.location.origin + window.location.pathname
    }

    visibleGrossiers.sort(sortGrossier)

    return (
        <div className="grossiers-page">
            <GoogleMap
                mapContainerStyle={containerStyle}
                options={{
                    styles: styles,
                }}
                center={center}
                zoom={8}
                onLoad={onLoad}
                id="grossiersMap"
                mapContainerClassName="sm:h-[500px] h-[250px]"
                onUnmount={onUnmount}
            />

            <div className="bg-dark sm:py-10 py-6 text-light w-full mb-16">
                <div className="container grid grid-cols-12">
                    <div className="xl:col-span-5 lg:col-span-6 md:col-span-8 col-span-12">
                        <h4 className="mb-6">
                            Vind een AUTOEXCELLENT <br />bij jou in de buurt
                        </h4>
                        <form
                            method="get"
                            onSubmit={handleSearch}
                            className="sm:flex"
                        >
                            <input
                                className="w-full -mr-7 pr-7 bg-light sm:mb-0 mb-4"
                                type="text"
                                name="location"
                                onInput={handleChange}
                                value={fields.location}
                                placeholder="Postcode of woonplaats"
                                required
                            />
                            <button
                                className="button primary w-[220px] flex-none"
                                type="submit"
                            >
                                Vestiging zoeken
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <section className="editor-container xl:!px-0 sm:!px-10 !px-6 normal">
                {isLoading ? (
                    <div className="w-100 d-flex justify-content-center">
                        <Spinner />
                    </div>
                ) : (
                    <div ref={ref}>
                        <h4 className="text-dark mb-4 flex items-end">
                            Resultaten
                            <span className="ml-6 font-normal text-sm text-[#8B8B8B] pb-1">
                                {visibleGrossiers.length}{" "}
                                {visibleGrossiers.length === 1
                                    ? "vestiging"
                                    : "vestigingen"}{" "}
                                gevonden
                            </span>
                        </h4>
                        {visibleGrossiers.map((grossier) => (
                            <Row key={grossier.title} grossier={grossier} />
                        ))}
                    </div>
                )}
            </section>
        </div>
    )
}

function Row({ grossier }) {
    return (
        <div className="card-shadow sm:mb-10 mb-6 vestigingen-row">
            <div className="grid grid-cols-12 gap-x-4">
                <div className="lg:col-span-8 sm:col-span-7 col-span-12 flex flex-col sm:p-10 p-4">
                    <h4 className="mb-2">
                        <span dangerouslySetInnerHTML={{ __html: grossier.title}} />
                        {grossier.distance !== undefined && (
                            <span className="mb-10">
                                &nbsp;- {grossier.distance} km
                            </span>
                        )}
                    </h4>
                    <div>{grossier.street}</div>
                    <div>{grossier.zipcode}</div>
                    <div>{grossier.city}</div>
                    <a
                        href={`https://google.com/maps/dir/?api=1&travelmode=driving&destination=${grossier.street},${grossier.zipcode} ${grossier.city}`}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="mb-6"
                    >
                        {"> "}Naar routebeschrijving
                    </a>

                    <div className="flex flex-col">
                        <a href={`tel:${grossier.phone}`}>{grossier.phone}</a>
                        <a href={`mailto:${grossier.email}`}>
                            {grossier.email}
                        </a>
                    </div>
                </div>

                <div className="lg:col-span-4 sm:col-span-5 col-span-12 flex justify-end sm:p-10 p-4 sm:pt-10 pt-0">
                    <div
                        className={`flex sm:flex-col w-full sm:text-base text-xs justify-between items-center text-center  ${
                            grossier.manager_image
                                ? "mt-auto mb-auto"
                                : "justify-end"
                        }`}
                    >
                        {grossier.manager_image && (
                            <>
                                <img
                                    className="sm:w-20 sm:h-20 w-12 h-12 object-cover rounded-full sm:mb-2"
                                    src={grossier.manager_image}
                                    alt=""
                                />
                                <div className="flex flex-col">
                                <span>{grossier.manager}</span>
                                <span>{grossier.manager_function}</span>
                                </div>
                                
                            </>
                        )}

                        <a
                            className={`button primary lg:w-[215px] sm:!text-base !text-sm w-auto ${
                                grossier.manager_image ? "mt-5" : ""
                            }`}
                            target="_blank"
                            rel="noreferrer noopener"
                            href={grossier.url}
                        >
                            Naar website
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Grossiers
